import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'USER_SETTINGS' });



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/user/handlers.js